import React from 'react';
import XMLPreview from './XMLPreview';
import { getPreviewDOM } from '../../services/TransformationsService';
import { Credentials } from '../../services/ApiType';

interface Props {
  url: string;
  credentials?: Credentials;
}

function XMLDOMPreview({ url, credentials }: Readonly<Props>) {
  const fetchXml = () => getPreviewDOM(
    url,
    credentials,
  );

  return (
    <XMLPreview
      header="DOM preview"
      errorMessage="Invalid XML url."
      fetchXml={fetchXml}
    />
  );
}

export default XMLDOMPreview;
